export default __webpack_public_path__ + "static/media/tele-plan-carousel-1-tata.e881f7fd.png";